export function initGoogleAutoSuggest(options: InitGoogleAutoSuggestOptions) {
  const {
    inputId, types, onPlaceChanged, searchAction, onFormChange
  } = options;
  const input = document.getElementById(inputId);
  const autocomplete = new (window as any).google.maps.places.Autocomplete(
    (input), {
      types: [types],
      componentRestrictions: { country: ['us', 'gu', 'mp'] }
    }
  );

  autocomplete.addListener('place_changed', () => {
    onPlaceChanged(autocomplete, onFormChange, searchAction);
  });

  (window as any).google.maps.event.addDomListener(input, 'keydown', (event) => {
    if (event.key === 'Enter') {
      event.preventDefault();
    }
  });
}

export function geocodeGooglePlace(placeId: string):Promise<GeometryLocation> {
  return new Promise((resolve, reject) => {
    try {
      const geocoder = new (window as any).google.maps.Geocoder();
      geocoder.geocode({ placeId }, (results) => {
        if (!results.length) return;
        const lat = results[0].geometry?.location.lat();
        const lng = results[0].geometry?.location.lng();
        resolve({ lat, lng });
      });
    } catch (error) {
      reject(error);
    }
  });
}

export function removeGoogleAutocomplete(inputId) {
  (window as any).google.maps.event.clearListeners(document.getElementById(inputId));

  // remove .pac-container(auto complete dropdown from Google)
  // after disabling autocomplete listener
  const removeElements = (elms) => elms.forEach((el) => el.remove());
  removeElements(document.querySelectorAll('.pac-container'));
}
